import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'

import mediaFailed from '../../images/media-failed.jpg'

export default function MediaFailed() {
    const { playList } = useSelector(state => state.messages)
    const { playListIndex } = useSelector(state => state.harmonize)
    const { name } = playList[playListIndex]
    const [portrait, setIsPortrait] = useState(window.innerWidth > window.innerHeight ? false : true)

    useEffect(() => {
        const handleOrientationChange = () => {
            setIsPortrait(window.screen.orientation.type.startsWith('portrait'))
        }
        window.screen.orientation.addEventListener('change', handleOrientationChange)
        return () => {

            window.screen.orientation.removeEventListener('change', handleOrientationChange)
        }
    }, [])

    return (
        <div style={{
            backgroundImage: `url(${mediaFailed})`,
            backgroundSize: portrait ? 'cover' : 'contain',
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'center',
            opacity: 1,
            display: 'flex', flexDirection: 'column', width: '100vw', height: '100vh',
            backgroundColor: 'lightblue', justifyContent: 'center', alignItems: 'center',
            paddingLeft: '10vw', paddingRight: '10vw'

        }}>
            <h4 style={{ textAlign: 'center' }}>The media for {name} could not be prepared :(</h4>
        </div>
    )
}